module.exports = __webpack_public_path__ + "img/chess_chesswhite2.c1ab6c31.png";